<template>
<el-dialog title="详情" :visible.sync="dialogVisible">
  <div class="content">
    <section>
        <el-row>
          <el-col :span="2" >
              <span >店铺名称:</span>
          </el-col>
          <el-col :span="7" >
              <span style="float:left">{{shopInfo.shopName}}</span>
          </el-col>
          <el-col :span="2" >
              <span >店铺行业:</span>
          </el-col>
          <el-col :span="7" >
              <span style="float:left">{{shopInfo.shopVocationValue}}</span>
          </el-col>
        </el-row>
        <el-row style="margin-top:5px;">
          <el-col :span="2" >
              <span >店铺地址:</span>
          </el-col>
          <el-col :span="16">
              <span style="float:left">{{shopInfo.shopLocation}}</span>
          </el-col>
        </el-row>
        <el-row style="margin-top:5px;">
          <el-col :span="2">
              <span >店铺简介:</span>
          </el-col>
          <el-col :span="21">
              <span style="float:left">{{shopInfo.shopDescribe}}</span>
          </el-col>
        </el-row>
        <el-divider style="margin-top:5px;"></el-divider>
        <el-row style="margin-top:5px;">
          <el-col :span="2">
              <span >联系人:</span>
          </el-col>
          <el-col :span="7" >
              <span style="float:left">{{shopInfo.linkman}}</span>
          </el-col>
          <el-col :span="2">
              <span>联系电话:</span>
          </el-col>
          <el-col :span="7">
              <span style="float:left">{{shopInfo.telphone}}</span>
          </el-col>
        </el-row>
        <el-row style="margin-top:5px;">
          <el-col :span="2">
              <span>身份证号:</span>
          </el-col>
          <el-col :span="7">
              <span style="float:left">{{shopInfo.idCardNumber}}</span>
          </el-col>
        </el-row>
        <el-row style="margin-top:5px;">
          <el-col :span="8">
              <span>正面照片</span>
          </el-col>
          <el-col :span="8">
              <span>背面照片</span>
          </el-col>
        </el-row>
        <el-row style="margin-top:5px;">
          <el-col :span="8" >
              <img class="avatar" :src="shopInfo.idCardFront?shopInfo.idCardFront:require('../assets/avatar.png')"  min-width="70" height="70" />
          </el-col>
          <el-col :span="8" >
              <img class="avatar" :src="shopInfo.idCardBack?shopInfo.idCardBack:require('../assets/avatar.png')"  min-width="70" height="70" />
          </el-col>
        </el-row>
        <el-row style="margin-top:5px;">
          <el-col :span="8" >
              <span>营业执照</span>
          </el-col>
          <el-col :span="8" >
              <span>门店logo</span>
          </el-col>
          <el-col :span="8">
              <span>门头照片</span>
          </el-col>
        </el-row>
        <el-row style="margin-top:5px;">
          <el-col :span="8">
              <img class="avatar" :src="shopInfo.businessLicense?shopInfo.businessLicense:require('../assets/avatar.png')"  min-width="70" height="70" />
          </el-col>
          <el-col :span="8">
              <img class="avatar" :src="shopInfo.shopLogo?shopInfo.shopLogo:require('../assets/avatar.png')"  min-width="70" height="70" />
          </el-col>
          <el-col :span="8">
              <img class="avatar" :src="shopInfo.shopPicture?shopInfo.shopPicture:require('../assets/avatar.png')"  min-width="70" height="70" />
          </el-col>
        </el-row>
      </section>
      <section style="margin-top:20px" v-if="propsData.showCz">
        <el-row>
            <el-col :span="24" style="text-align:center">
                <el-button type="danger" @click="failPassAudit()">审核不通过</el-button>
                <el-button type="primary" @click="passAudit()" >审核通过</el-button>
                <el-button type="default" @click="closeDialog()" >关闭</el-button>
            </el-col>
        </el-row>
      </section>
  </div>
</el-dialog>
</template>

<script>

  export default {
    name: "shopDetail",
    props: {
      propsData: {
        type: Object,
        default: () => {}
      }
    },
    data() {
      return {
        dialogVisible:false,
        shopInfo:{
          shopName:'测试',
          shopVocation:"",
          shopLocation:"",
          linkman:"",
          telphone:"",
          idNumber:"",
          avatar:""
        },
        
        CouponTypes:[{ label: '代金券', value: '1' }, { label: '免单卡', value: '2' },],
        userType3:false,
      }
    },
    watch: {
      propsData(val) {
        this.getMerchantInfoDetail();
        this.dialogVisible =true;
      },
    },
    methods: {
      formartCopenTyepe(row, column){
        let temp = this.CouponTypes.filter((item) => {
					return item.value == row.couponType;
				})
				return temp[0].label;
      },
      async getMerchantInfoDetail(){
        let condition={};
        condition.merchantId = this.propsData.merchantId;
        let result =  await this.$http.post(this,'/merchant/getMerchantInfoDetail', {},condition);
        if (result && result.code == 200) {
            this.shopInfo =result.data.obj;
            if(result.data.userType !=1){
                this.userType3 =true;
            }
        }
      },

      async failPassAudit(){
        let _this =this;
        _this.$prompt('', '不通过的原因', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(({ value }) => {
            _this.failPass(value);
        }).catch(() => {
         
        });
      },
      async failPass(value){
        let condition ={};
        condition.userId = this.userId;
        condition.merchantId = this.propsData.merchantId;
        condition.failReason = value;
        condition.checkStatus ='3';
        let result  =  await this.$http.post(this,'/merchant/checkMerchantInfo', {},condition);
        if (result && result.code == 200) {
            this.dialogVisible =false;
            this.$emit('fatherMethod');
        }
      },
      async passAudit(){
        let condition ={};
        condition.userId = this.userId;
        condition.merchantId = this.propsData.merchantId;
        condition.checkStatus ='4';
        let result  =  await this.$http.post(this,'/merchant/checkMerchantInfo', {},condition);
        if (result && result.code == 200) {
            this.dialogVisible =false;
            this.$emit('fatherMethod');
        }
      },
      closeDialog(){
        this.dialogVisible =false;
      }
    },
    created() {
      this.dialogVisible =true;
      this.getMerchantInfoDetail();
    }
  }
</script>

<style scoped>
  .toolbar {
    background: #f2f2f2;
    padding: 10px;
    margin: 10px 0px;
  }
  .el-form-item {
    margin-bottom: 10px;
    width: 20%;
  }


  .icon-class {
    font-size: 30px;
    position: relative;
    vertical-align: sub;
    margin-left: 15px;
  }

  .form-class {
    margin-left: 1%;
  }
</style>
